<template>
    <v-tooltip-wrapper :open-on-click="false"
                       :tooltip-position="tooltipPosition">
        <template #activator="{ on, attrs }">
            <span
                :class="[...spanClasses]"
                :style="spanStyle"
                v-bind="{...$attrs, ...attrs}"
                v-on="{...$listeners, ...on}">
                <slot />
            </span>
        </template>
        <span v-if="tooltipText">{{ tooltipText }}</span>
    </v-tooltip-wrapper>
</template>

<script>
import { defineComponent } from 'vue'
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default defineComponent({
    components: { VTooltipWrapper },
    props: {
        tooltipText: String,
        spanStyle: String,
        spanClasses: {
            type: Array,
            default: () => []
        },
        /** @type {'top'|'bottom'|'left'|'right'} */
        tooltipPosition: {
            type: String,
            default: 'top'
        }
    }
})
</script>
